var app = angular.module("leonardo");

var OnDemandSubCategoriesController = function($scope, ngDialog, $state, OnDemandSubCategoryService, PermissionService,
                                               AccountUserService, FilterService, $controller, AuthDataService,
                                               ConfigThemeService) {

  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.configThemeService = ConfigThemeService;

  $scope.showCloneAdminDialog = function (subcategory) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/clone-element.html',
      controller: 'CloneTypeDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        onlyClientInstance: true,
        type: 'on demand subcategory',
      }
    }).then(function (result) {
      if (result.type_result === 'client_instance') {
        subcategory.cloneToWhiteLabel({clientinstances: result.client_instance}).then(function () {
          $scope.loadPage($scope.page);
        });
      }
    }, function () {
      return;
    });
  };

  $scope.showOnDemandDeleteDialog = function(item) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/on-demand-instructions/delete.html',
      controller: 'OnDemandDeleteDialog',
      data: {
        item: item,
        type: 'subcategory',
        message: 'Are you sure you want to delete this subcategory? All content in this subcategory library will be deleted and the action cannot be undone.'
      }
    }).then(function() {
      OnDemandSubCategoryService.updateCollection(item, true);
    }, function () {
      return;
    });
  };

  $scope.goToForm = function(item) {
    $state.go('on-demand-instructions.subcategory-edit', {pk: item.id});
  };

  $scope.getEntitiesPromise = function(options) {
    options['search'] = FilterService.getFilter('search');
    options['client_instance'] = FilterService.getFilter('client_instances', true);
    options['category'] = FilterService.getFilter('category');
    if (AuthDataService.isNotStaff()) {
      var account = null;
      if(AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.account){
        account = AccountUserService.currentAccountUser.account.id || AccountUserService.currentAccountUser.account;
      }
      if (isNull(account)) {
        account = FilterService.accounts.length > 0 ? FilterService.accounts[0].id : null;
      }
      options['account'] = account;
    }
    return OnDemandSubCategoryService.getlist(options);
  };

  $scope.goToItem = function(item) {
    $state.go('on-demand-instructions.subcategory', {pk: item.id});
  };

  $scope.$on('on-demand-instruction:updated', function(){
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', { $scope: $scope });

  $scope.loadPage(1);

};

app.controller('OnDemandSubCategoriesController', ['$scope', 'ngDialog', '$state', 'OnDemandSubCategoryService',
  'PermissionService', 'AccountUserService', 'FilterService', '$controller', 'AuthDataService', 'ConfigThemeService',
  OnDemandSubCategoriesController]);
